<template>
  <v-container fluid tag="section">
    <v-row justify="space-between">
      <v-col cols="4">
        <v-autocomplete
          v-model="organizationFilter"
          :items="organizationFilterOptions"
          color="orange"
          item-text="name"
          item-color="orange"
          return-object
          label="Organization"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="search"
          placeholder="Search Users By Name or Email"
          prepend-inner-icon="mdi-account-search"
          outlined
          color="orange"
        />
      </v-col>
    </v-row>
    <v-data-table
      id="organizations-table"
      :headers="headers"
      :items="userList"
      :items-per-page.sync="itemsPerPage"
      class="elevation-2"
      height="100%"
      :server-items-length="queryMatches"
      :page.sync="page"
      :loading="isLoading"
      :footer-props="{ 'items-per-page-options': [5, 10] }"
      disable-sort
    >
      <template v-slot:item.activated="{ item }">
        <v-icon v-if="item.activated" color="green">mdi-check</v-icon>
        <v-icon v-else color="red">mdi-close-circle</v-icon>
      </template>
    </v-data-table>
    <add-user-button
      @invite-response="showInviteResponseSnackbar"
    />
    <BaseSnackbar
      :visible="snackbarVisible"
      :text="snackbarText"
      @close="snackbarVisible = false"
      class="snackbar"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import BaseSnackbar from '@/components/base/BaseSnackbar'

export default {
  name: 'UserTable',

  components: {
    // AddUserButton: () => import('./AddUserButton'),
    BaseSnackbar
  },

  data () {
    return {
      organizationFilter: {
        name: 'All',
        uuid: ''
      },
      search: '',
      headers: [
        { text: 'Full name', align: 'start', value: 'name' },
        { text: 'Username', align: 'start', value: 'username' },
        { text: 'Organization', value: 'organization' },
        { text: 'Email', value: 'email' },
        { text: 'User Type', value: 'class' },
        { text: 'Activated', align: 'center', value: 'activated' }
      ],
      itemsPerPage: 10,
      page: 1,
      isLoading: false,
      snackbarVisible: false,
      snackbarText: '',
      snackbarDefaultTimeout: 5000
    }
  },

  async created () {
    await this.setupState()
    await this.requestAllOrganizations()
    await this.scroll()
  },

  computed: {
    ...mapState({
      organizations: state => state.organization.organizations,
      userList: state => state.organization.userList,
      queryMatches: state => state.organization.queryMatches
    }),

    totalUsers () {
      if (this.organizations.length > 0) {
        return this.organizations.map(o => o.userCount).reduce((uc1, uc2) => {
          return uc1 + uc2
        })
      }
      return 0
    },

    organizationFilterOptions () {
      const organizationsCopy = JSON.parse(JSON.stringify(this.organizations))
      organizationsCopy.unshift({
        uuid: '',
        name: 'All'
      })
      return organizationsCopy
    }
  },

  watch: {
    organizationFilter () {
      this.page = 1
      this.scroll()
    },

    search () {
      this.scroll()
    },

    page () {
      console.log(this.organizationFilter)
      this.scroll()
    },

    itemsPerPage () {
      this.scroll()
    }
  },

  methods: {
    ...mapActions(['setupState', 'requestAllOrganizations', 'requestScrollUsers']),

    async scroll () {
      this.isLoading = true
      await this.requestScrollUsers({
        size: this.itemsPerPage,
        page: this.page,
        organization: this.organizationFilter,
        name: this.search,
        email: this.search
      })
      this.isLoading = false
    },

    showInviteResponseSnackbar (response) {
      this.scroll()
      if (response.success) {
        this.showSnackbar('Successfully sent email invite to platform.')
      } else {
        this.showSnackbar(`Could not send email. ${response.message}`, 7000)
      }
    },

    showSnackbar (text, timeout = null) {
      let snackbarTimeout = this.snackbarDefaultTimeout
      if (timeout !== null) {
        snackbarTimeout = timeout
      }

      this.snackbarText = text
      this.snackbarVisible = true
      setTimeout(() => { this.snackbarVisible = false }, snackbarTimeout)
    }
  }
}
</script>

<style lang="sass" scoped>
  #organizations-table .v-data-footer
    justify-content: start
</style>
